import { Dealer } from './dealer.model';

export const enum LeadSource {
  PHONE = 'Phone',
  WEBSITE = 'Website',
  EMBED = 'Embed',
  EMBED_MAZO = 'Mazo Website',
}

export interface Application {
  id?: string;
  createdAt?: Date;

  viewedBy?: string;
  isArchived?: boolean;

  firstName: string;
  middleName: string;
  lastName: string;
  suffix: string;
  emailAddress: string;
  maritalStatus: string;
  birthdate: string;
  primaryPhoneType: string;
  primaryPhoneNumber: string;
  ssn: string;

  // step# 2
  residentialAddressLine1: string;
  residentialAddressLine2: string;
  residentialCity: string;
  residentialState: string;
  residentialZipCode: string;
  yearsAtResidentialAddress: string;
  monthsAtResidentialAddress: string;
  statusAtResidentialAddress: string;
  monthlyPayment: string;
  previousAddressLine1: string;
  previousAddressLine2: string;
  previousCity: string;
  previousState: string;
  previousZipCode: string;
  previousYearsAtAddress: string;
  previousMonthsAtAddress: string;

  isRegistrationAddress: string;
  registrationAddress: string;
  isMailingAddress: string;
  mailingAddress: string;

  isRetired: boolean;
  retirementIncome: string;
  retirementYears: string;
  retirementMonths: string;

  isEmployed: boolean;
  employerName: string;
  employerPhoneNumber: string;
  occupationTitle: string;
  grossMonthlyIncome: string;
  employerAddressLine1: string;
  employerCity: string;
  employerState: string;
  employerZipCode: string;
  employedYears: string;
  employedMonths: string;

  previousEmployerName: string;
  // previousEmployerPhoneNumber: string;
  previousOccupationTitle: string;
  previousGrossMonthlyIncome: string;
  previousEmployedYears: string;
  previousEmployedMonths: string;

  isAdditionalIncome: boolean;
  additionalIncomeSource: string;
  additionalIncomeSourceOther: string;
  additionalMonthlyIncome: string;

  haveCoApplicant: boolean;
  coapplicantFirstName: string;
  coapplicantMiddleName: string;
  coapplicantLastName: string;
  coapplicantSuffix: string;
  coapplicantPrimaryPhoneType: string;
  coapplicantPrimaryPhoneNumber: string;
  coapplicantEmailAddress: string;
  coapplicantMaritalStatus: string;
  coapplicantSsn: string;
  coapplicantBirthdate: string;
  coapplicantResidentialAddressLine1: string;
  coapplicantResidentialCity: string;
  coapplicantResidentialState: string;
  coapplicantResidentialZipCode: string;
  coapplicantYearsAtResidentialAddress: string;
  coapplicantMonthsAtResidentialAddress: string;
  coapplicantStatusAtResidentialAddress: string;
  coapplicantMonthlyPayment: string;

  coapplicantPreviousAddressLine1: string;
  coapplicantPreviousCity: string;
  coapplicantPreviousState: string;
  coapplicantPreviousZipCode: string;
  coapplicantPreviousYearsAtAddress: string;
  coapplicantPreviousMonthsAtAddress: string;

  coapplicantIsRetired: boolean;
  coapplicantRetirementIncome: string;
  coapplicantRetirementYears: string;
  coapplicantRetirementMonths: string;

  coapplicantIsEmployed: boolean;
  coapplicantEmployerName: string;
  coapplicantOccupationTitle: string;
  coapplicantGrossMonthlyIncome: string;
  coapplicantEmployerAddressLine1: string;
  coapplicantEmployerCity: string;
  coapplicantEmployerState: string;
  coapplicantEmployerZipCode: string;
  coapplicantEmployerPhoneNumber: string;
  coapplicantEmployedYears: string;
  coapplicantEmployedMonths: string;

  coapplicantPreviousEmployerName: string;
  // coapplicantPreviousEmployerPhoneNumber: string;
  coapplicantPreviousOccupationTitle: string;
  coapplicantPreviousGrossMonthlyIncome: string;
  coapplicantPreviousEmployedYears: string;
  coapplicantPreviousEmployedMonths: string;

  coapplicantIsAdditionalIncome: boolean;
  coapplicantAdditionalIncomeSource: string;
  coapplicantAdditionalIncomeSourceOther: string;
  coapplicantAdditionalMonthlyIncome: string;

  // step #4
  sellerType: string;
  sellerName: string;
  sellerPhoneNumber: string;
  sellerContact: string;
  vehicleYear: string;
  vehicleMake: string;
  vehicleModel: string;
  vehicleSalesPrice: string;
  vehicleDownPayment: string;
  notes: string;
  referralSource: string;
  referralSourceOther: string;

  // step #5
  usCitizen: boolean;
  usResident: boolean;
  applicantAgree: boolean;
  applicantSignature: string;
  coApplicantAgree?: boolean;
  coApplicantSignature?: string;
  coApplicantUsCitizen?: boolean;
  coApplicantUsResident?: boolean;

  // dealer info
  dealerId?: string;
  dealerName?: string;
  dealerLocation?: string;
  dealerStock?: string;

  dealerDetails?: Dealer;

  // phone application
  isPhoneApplication?: boolean;
  createdBy?: string;
  createdByPosition?: string;
  phoneNumberCallback?: string;

  leadSource: LeadSource;

  alerts?: {
    alertType: string;
    alertMessage: string;
    alertSeverity: string;
    alertTimestamp: number;
  }[];

  emailAlerts?: {
    alertType: string;
    alertMessage: string;
    alertSeverity: string;
    alertTimestamp: number;
  }[];

  // custom attributes
  customAttributes?: Record<string, string>;

  analyticName?: string;
  analystName?: string;
}

export interface CreateApplicationRequest extends Omit<Application, 'id' | 'createdAt' | 'viewedBy'> {
  token: string;
}
